import { hypertensionSteps } from "../onboarding/hypertensionSteps";
import { disqualificationSteps } from "../onboarding/disqualificationSteps";
import { landingPageSteps } from "../onboarding/landingPageSteps";
import { FlowConfig } from "./types";
import HypertensionRecommendationContent from "./hypertension/HypertensionRecommendationContent";

export const hypertensionFlow: FlowConfig = {
  id: "hypertension",
  displayName: "Högt blodtryck",
  treatmentArea: "HYPERTENSION",
  landingPath: "/hypertoni",
  entryStepId: "q1",
  pageTitle: "Blodtrycksdoktorn - Effektiv behandling för högt blodtryck",
  landing: {
    headline: "Hej! Vi finns här för dig som vill ha hjälp med blodtrycket.",
    bulletPoints: [
      "Din egen sjuksköterska och läkare",
      "Snabb utredning",
      "Kontinuerlig behandling till fast låg månadskostnad",
      "Ingen bindningstid",
    ],
    additionalText:
      "Svara på några snabba frågor och se hur vi kan hjälpa dig!",
    ctaText: "Svara på frågorna",
    disclaimer:
      'Blodtrycksdoktorn är inte en akuttjänst. Vid akuta besvär ring 112. <a href="https://blodtrycksdoktorn.se/priser/" target="_blank">Se priser här</a>.',
  },
  RecommendationContent: HypertensionRecommendationContent,
  steps: {
    ...hypertensionSteps,
    d1: disqualificationSteps.d1,
    d4: disqualificationSteps.d4,
    l1: landingPageSteps.l1,
  },
  entryStepIds: ["q1", "l1"],
  progressPath: ["q1", "q2", "q3", "q4", "q32", "q12", "q6", "q13", "q33"],
};
